import { useEffect, useRef } from 'react';
import { useFormContext, Controller, useWatch } from 'react-hook-form';
// @mui
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';

interface ICasRHFUpload {
  name: string;
  accept: string;
  label?: string;
}

/**
 * @param accept Use "*" to allow all file types.
 * accept must always be specified.
 * @param label Optional caption above the file input - use when it isn't obvious what
 * picking a file will do (e.g. adding another file vs replacing the current one).
*/

export default function CasRHFUpload({ name, accept, label }: ICasRHFUpload) {
  const { control } = useFormContext();
  const fileRef = useRef<HTMLInputElement | null>(null);

  const selectedFile = useWatch({ control, name });

  useEffect(() => {
    if (!selectedFile && fileRef.current) fileRef.current.value = '';
  }, [selectedFile]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref, ...rest }, fieldState: { error } }) => (
        <div>
          {label && <FormLabel sx={{ display: 'block', mb: 1 }}>{label}</FormLabel>}
          <input
            type="file"
            accept={accept}
            ref={fileRef}
            onChange={(e) => {
              if (e.target.files) onChange(e.target.files[0]);
            }}
            {...rest}
          />
          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
